import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: ${Colors.blueGray};
`;

export const TitleIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${Colors.primaryPurple};
`;

export const InfoBtn = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${Colors.lightGray};
  margin-left: 2px;

  &:hover {
    color: ${Colors.blueGray};
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: ${Colors.blueMist};
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  width: 220px;
  white-space: normal;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s;
  z-index: 20;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  ${TooltipWrapper}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  color: ${Colors.blueMist};
  margin-bottom: 6px;
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 9px 12px;
  border: 1px solid ${Colors.ultraLightGray};
  border-radius: 6px;
  font-size: 14px;
  color: ${Colors.blueGray};
  outline: none;
  box-sizing: border-box;
  background: #fff;

  &:focus {
    border-color: ${Colors.primary};
  }

  &::placeholder {
    color: ${Colors.lightGray};
  }

  &:disabled {
    background: ${Colors.ultraLightGray};
    cursor: not-allowed;
  }
`;

export const DateRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const StatusLabel = styled.span`
  font-size: 13px;
  color: ${Colors.blueMist};
  font-weight: 500;
`;

export const StatusBadge = styled.span`
  background: ${({ bg }) => bg};
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 16px;
  border-radius: 99px;
`;

export const ActionButton = styled.button`
  width: 100%;
  padding: 11px;
  border-radius: 99px;
  border: none;
  background: ${({ bg }) => bg || Colors.primary};
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  margin-bottom: 18px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.88;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${Colors.ultraLightGray};
  margin: 4px 0 18px;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

export const CancelBtn = styled.button`
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  color: ${Colors.blueGray};
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 99px;

  &:hover {
    background: ${Colors.ultraLightGray2};
  }
`;

export const ConfirmBtn = styled.button`
  padding: 9px 28px;
  border-radius: 8px;
  border: none;
  background: ${({ bg, disabled }) => (disabled ? Colors.ultraLightGray : bg || Colors.primary)};
  color: ${({ disabled }) => (disabled ? Colors.lightGray : "#fff")};
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

export const ConfirmBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0 16px;
`;

export const ConfirmIcon = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${({ color }) => color || Colors.primaryPurple};
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ConfirmText = styled.p`
  font-size: 14px;
  color: ${Colors.blueMist};
  margin: 0;
  line-height: 1.5;
`;
